import { getGoogleTranslateKey } from './requestHelper';
import axios from 'axios';
export const googleTranslate = async (original,target)=>{
   const key= await getGoogleTranslateKey();
   const url = `https://translation.googleapis.com/language/translate/v2?key=${key}&q=${original}&target=${target}`;
   const response = await axios.get(url);
   return response.data.data.translations[0].translatedText;
};

